import React from "react";
import { Badge } from "@mui/material";
import { TypeIcon } from "./TypeIcon";
import styles from "./MultipleDragPreview.module.css";

export const MultipleDragPreview = (props) => {
  return (
    <Badge
      classes={{ badge: styles.badge }}
      color="error"
      badgeContent={props.dragSources.length}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <div className={styles.root} data-testid="custom-drag-preview">
        {props.dragSources.map((node) => (
          <div className={styles.item}>
            <div className={styles.icon}>
              <TypeIcon
                droppable={node.droppable || false}
                fileType={node?.data?.fileType}
              />
            </div>
            <div className={styles.label}>{node.text}</div>
          </div>
        ))}
      </div>
    </Badge>
  );
};
